import { Component, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IMenu } from '../../interfaces/menu';
import { HandleScreenService } from '../../services/handle-screen.service';

@Component({
  selector: 'ui-header',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnChanges{
  @Input() backMenuLabel: string = '';
  @Input() backMenuLink: string = '';
  @Input() showIconBacheca: boolean = false;
  @Input() isBackMenuVisibile: boolean = false;
  @Input() isSecondLogoVisibile: boolean = true;
  @Input() isSecondMenuVisibile: boolean = true;
  @Input() stopNavigate: boolean = false;
  @Input() isLogged: boolean = false;
  @Input() closeMenuMobile: boolean = false;
  @Input() primaryMenu: IMenu[] = [];
  @Input() primaryMenuMobile: IMenu[] = [];
  @Input() secondaryMenu: IMenu[] = [];
  @Input() showNotificationBanner: boolean = false;
  @Input() notificationBannerText: string = '';
  @Output() clickItemMenu: EventEmitter<string> = new EventEmitter<string>();
  @Output() resetToggleMenuMobile: EventEmitter<boolean> = new EventEmitter<boolean>();

  public isMobileMenuOpened: boolean = false;

  get isMobile(): boolean {
    return this.handleScreenService.isMobile();
  }

  constructor(private handleScreenService: HandleScreenService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['closeMenuMobile']?.currentValue){
      this.isMobileMenuOpened = false;
      this.resetToggleMenuMobile.emit(false);
    }
  }

  menuSelect(id: string): void {
    if(this.stopNavigate){
      return;
    }
    this.clickItemMenu.emit(id);
    if(id){
      this.toggleChecked();
    }
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.handleScreenService.updateScreenWidth();
  }

  toggleChecked(): void{
    this.isMobileMenuOpened = !this.isMobileMenuOpened;
  }
}
